import React from 'react';
import {StoreResultResponse} from 'app/components/match/liveResult/types';
import {AwayGoal, HomeGoal, MatchScore} from 'app/components/match/MatchDetailHeaderStyles';
import {Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

interface MatchResultProps {
  data: StoreResultResponse | null;
}

export default function MatchResult({data}: MatchResultProps) {
  if (!data) {
    return <div />;
  }
  return (
    <Container>
      <MatchScore>
        <HomeGoal>
          <Typography variant='display2'>{data.homeGoals}</Typography>
        </HomeGoal>
        <Typography variant='display2'>:</Typography>
        <AwayGoal>
          <Typography variant='display2'>{data.awayGoals}</Typography>
        </AwayGoal>
      </MatchScore>
      <Typography variant='caption1'>
        {data.minute}'{data.additionalMinute ? `+${data.additionalMinute}` : ''}
      </Typography>
    </Container>
  );
}
